<template>
  <div v-if="showTelephone" class="mt-2 is-flex is-align-items-center">
    <small class="mr-2">
      Recapiti:
    </small>
    <div v-if="client && client.contacts && client.contacts.length" class="is-flex">
      <small v-for="(contact, index) in client.contacts" :key="index" class="mr-2">
        {{ contact.telephone }} <span v-if="contact.name">({{ contact.name }})</span>
      </small>
    </div>
    <div v-else-if="client && client.contacts && client.contacts.length === 0">
      <small><i>Nessuno</i></small>
    </div>
    <div v-else>
      <small>--</small>
    </div>
  </div>

  <div v-if="showAddress" class="mt-2 is-flex is-align-items-center">
    <small class="mr-2">
      Indirizzo:
    </small>
    <small class="is-flex" style="width: 100%;">
      <AddressDisplay :value="client" />
    </small>
  </div>
</template>

<script>
import AddressDisplay from './AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  props: {
    client: {
      type: Object,
      default: {}
    },
    showTelephone: {
      type: Boolean,
      default: true
    },
    showAddress: {
      type: Boolean,
      default: false
    }
  }
}
</script>